import styled from "@emotion/styled";
import React from "react";
import brandLogo from "../../assets/images/brand-logo.png";
import { VerticalGap } from "../styled/gaps";
import { NavLinks } from "./NavLinks";

const LeftSection = styled.div`
  width: 250px;
  background-color: #002979;
  height: 100vh;
`;

const BrandSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Logo = styled.div`
  color: #fff;
`;

const OrgName = styled.div`
  color: #fff;
`;

const LeftNav = (props) => {
  return (
    <LeftSection>
      <VerticalGap size={"20px"} />
      <BrandSection>
        <Logo>
          <img src={brandLogo} alt="brand logo" />
        </Logo>
        <OrgName>{"ABC Spa & Salon".toLocaleUpperCase()}</OrgName>
      </BrandSection>
      <VerticalGap size={"20px"} />
      <NavLinks />
    </LeftSection>
  );
};

export { LeftNav };
